import React, { Suspense } from 'react'
import { initReactI18next } from 'react-i18next'
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { StyleSheet, View } from 'react-native'
import { Slot, RouterProvider } from 'zens-router'
import { Color, OutsidePressProvider } from 'zens-storybook'
import { QueryProvider, StoreProvider } from 'zens-store'
import { FontProvider, ToastProvider } from '@dms/provider'
import Constants from 'expo-constants'
import * as Sentry from '@sentry/react'
import { ErrorBoundary } from 'react-error-boundary'
import { Redirect } from 'zens-router'

import Locales from '../../../locales'

const styles = StyleSheet.create({
  container: {
    width: '100%',
    flex: 1,
    backgroundColor: Color.backgroundGrey,
    height: '100%',
  },
})

if (Constants.expoConfig?.extra?.sentry && !__DEV__) {
  Sentry.init({
    integrations: [Sentry.browserTracingIntegration()],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/.*ondigitalocean.app\/api/,
      /^https:\/\/.*\.digitaloceanspaces\.com\/zens/,
    ],
    ...Constants.expoConfig?.extra.sentry,
  })
}

function AppLayout() {
  const deeplinkBaseUrl = typeof window !== 'undefined' ? window.location.origin : ''

  return (
    <View style={styles.container}>
      <RouterProvider>
        <StoreProvider
          config={{
            ...Constants.expoConfig?.extra,
            deeplink: {
              baseUrl: deeplinkBaseUrl,
            },
            i18n: {
              module: initReactI18next,
              resources: Locales,
            },
            api: {
              ...Constants.expoConfig?.extra?.api,
              onError: (error) => {
                Sentry.captureException(error)
              },
            },
            geo: {
              apiKey: Constants.expoConfig?.extra?.maps?.apiKey,
            },
          }}
        >
          <QueryProvider>
            <OutsidePressProvider>
              <ErrorBoundary
                fallbackRender={({ error }) => {
                  const status = (error as any)?.status
                  if (status === 403) return <Redirect href="/forbidden" />
                  if (status === 401) return <Redirect href="/unauthorized" />
                  return <Redirect href="/general-error" />
                }}
              >
                <Suspense fallback={null}>
                  <FontProvider>
                    <ToastProvider>
                      <Slot />
                    </ToastProvider>
                  </FontProvider>
                </Suspense>
              </ErrorBoundary>
            </OutsidePressProvider>
            {/* <ReactQueryDevtools initialIsOpen={false} /> */}
          </QueryProvider>
        </StoreProvider>
      </RouterProvider>
    </View>
  )
}

export default AppLayout
